import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class HydrationError extends CustomError {
	constructor(error: Error | string) {
		super(error instanceof Error ? `Hydration failure: ${error.message}` : `Hydration failure: ${error}`);
	}
}
setClassName(HydrationError, 'HydrationError');
